import Image from "next/image"

export default function SupportInfo() {

  const data = [
    { title: 'تحویل اکسپرس', pic: '/footer/1.png' },
    { title: 'ضمانت بازگشت', pic: '/footer/2.png' },
    { title: 'پرداخت در محل', pic: '/footer/3.png' },
    { title: 'تضمین بهترین قیمت', pic: '/footer/4.png' },
    { title: 'ضمانت اصل بودن', pic: '/footer/5.png' },
    { title: 'ارسال به تمام نقاط', pic: '/footer/6.png' },
    { title: 'بسته بندی زیبا', pic: '/footer/7.png' },
  ]

  return (<div className="overflow-auto m-auto">
    <ul className="w-full max-w-1300 min-w-[900px] overflow-auto flex flex-row justify-around pb-6 m-auto">
      {data.map(item => (<li key={item.title} className="flex flex-col justify-center gap-2">
        <Image width={40} height={40} src={item.pic} className="m-auto" />
        <p className="text-[11px] justify-center">{item?.title}</p>
      </li>
      ))}
    </ul>
  </div>)
}